function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &__overlay {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: rgba(62, 68, 73, 0.93);\n    z-index: ",
        ";\n    pointer-events: auto;\n    &.--variant-embedded {\n      background-color: rgba(255, 255, 255, 0.95);\n    }\n    body.--ios-hack--repaint & {\n      transform: translateZ(0);\n      -moz-transform: translatez(0);\n      -ms-transform: translatez(0);\n      -o-transform: translatez(0);\n      -webkit-transform: translateZ(0);\n      -webkit-overflow-scrolling: touch;\n      touch-action: auto;\n      -webkit-user-select: none;\n      -webkit-touch-callout: none;\n      -webkit-user-drag: none;\n    }\n    ",
        "\n  }\n\n  &__content {\n    padding: ",
        ";\n    border-radius: 8px;\n    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.11);\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    position: absolute;\n    box-sizing: border-box;\n    outline: none;\n\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n\n    &.--variant-embedded {\n      box-shadow: none;\n      border: 1px solid #c9cdd4;\n      top: 40px;\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 0%);\n    }\n\n    &.--variant-admin-scrollable {\n      max-height: none;\n      height: 100%;\n\n      &.--dynamic {\n        max-height: 100%;\n        height: unset;\n        ",
        "\n      }\n    }\n\n    &.--product-modal {\n      background: transparent;\n      box-shadow: none;\n      border: none;\n      height: 100vh;\n      width: 1140px;\n      max-width: 80vw;\n      margin: 0 auto;\n      display: flex;\n      flex-direction: column;\n      max-height: unset;\n      position: unset;\n      transform: unset;\n      border-radius: 0;\n\n      @media ",
        " {\n        background-color: white;\n        max-width: 100vw;\n      }\n\n      @media ",
        " {\n        max-height: 100%;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        transform: none;\n        border-radius: 0px;\n        justify-content: flex-start;\n        position: static;\n      }\n    }\n\n    &.--dutchie-video-modal {\n      @media ",
        " {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: transparent;\n      }\n    }\n\n    &.--mobile-vertical-scroll {\n      overflow-y: scroll;\n      display: block;\n    }\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { space, textAlign, width, color, alignItems, justifyContent, flexDirection, top, border } from 'styled-system';
import { mediaQueries } from 'shared/styles';
var ReactModalAdapter = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(ReactModalAdapter, _React_Component);
    function ReactModalAdapter() {
        _class_call_check(this, ReactModalAdapter);
        var _this;
        _this = _call_super(this, ReactModalAdapter, arguments), _define_property(_this, "targetRef", /*#__PURE__*/ React.createRef()), _define_property(_this, "onModalOpen", function() {
            disableBodyScroll(_this.targetRef);
        }), _define_property(_this, "onModalClose", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var onRequestClose = _this.props.onRequestClose;
            enableBodyScroll(_this.targetRef);
            if (onRequestClose) {
                onRequestClose.apply(void 0, _to_consumable_array(args));
            }
        });
        return _this;
    }
    _create_class(ReactModalAdapter, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                try {
                    enableBodyScroll(this.targetRef);
                } catch (_e) {
                // console.error(e); // swallow error that occurs when
                // navigating between pages and a modal is open.
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, isOpen = _this_props.isOpen, className = _this_props.className, modifierClassName = _this_props.modifierClassName, variant = _this_props.variant, rest = _object_without_properties(_this_props, [
                    "isOpen",
                    "className",
                    "modifierClassName",
                    "variant"
                ]);
                var testId = rest['data-testid'];
                // `modifierClassName` is the caller's own `className` prop (renamed by the default
                // export below). `styled(ModalContainer)` wrappers inject a generated class here and
                // rely on it to style `__content`; direct `<ModalContainer>` usages may omit it, so
                // only append it when present, otherwise it stringifies to the literal word "undefined".
                var contentClassName = modifierClassName ? "".concat(className, "__content ").concat(modifierClassName) : "".concat(className, "__content");
                var overlayClassName = "".concat(className, "__overlay");
                // Add data-testid to the content class if it exists
                if (testId) {
                    contentClassName = "".concat(contentClassName, " modal-content-").concat(testId);
                }
                if (variant === 'embedded') {
                    contentClassName += ' --variant-embedded';
                    overlayClassName += ' --variant-embedded';
                }
                if (variant === 'admin-scrollable') {
                    contentClassName += ' --variant-admin-scrollable';
                    overlayClassName += ' --variant-admin-scrollable';
                }
                if (variant === 'admin-scrollable-dynamic') {
                    contentClassName += ' --variant-admin-scrollable --dynamic';
                    overlayClassName += ' --variant-admin-scrollable --dynamic';
                }
                if (variant === 'mobile-vertical-scroll') {
                    contentClassName += ' --mobile-vertical-scroll';
                }
                return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({
                    isOpen: isOpen,
                    className: contentClassName,
                    contentLabel: "Dutchie Modal",
                    contentRef: function(node) {
                        _this.targetRef = node;
                        if (node && testId) {
                            node.setAttribute('data-testid', testId);
                        }
                    },
                    onAfterOpen: this.onModalOpen,
                    onRequestClose: this.onModalClose,
                    overlayClassName: "".concat(overlayClassName, " ios-hack"),
                    portalClassName: className
                }, rest), {
                    data: {
                        cy: rest['data-cy'],
                        test: rest['data-test']
                    }
                }));
            }
        }
    ]);
    return ReactModalAdapter;
}(React.Component);
ReactModalAdapter = _ts_decorate([
    observer
], ReactModalAdapter);
var StyledModal = styled(ReactModalAdapter)(_templateObject(), function(param) {
    var important = param.important;
    return important ? 500 : 100;
}, function(props) {
    return props.scrollable && "\n      align-items: center;\n      display: flex;\n      justify-content: center;\n    ";
}, function(props) {
    if (props.fancy) {
        return '101px 47px 45px 47px';
    }
    if (props.noPadding) {
        return '0px';
    }
    if (props.sidePadding) {
        return '31px 5px 45px 5px';
    }
    return props.padding || '31px 47px 45px 47px';
}, function(props) {
    return !props.popUp && "\n      max-height: 100vh;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    ";
}, function(props) {
    return props.popUp && "\n      max-height: calc(100vh - 20px);\n      bottom: 0px;\n      left: 50%;\n      transform: translate(-50%, 0);\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n    ";
}, space, textAlign, width, color, alignItems, justifyContent, flexDirection, border, function(props) {
    return props.scrollable && "\n      position: relative;\n      display: inline-flex;\n      transform: none;\n      left: auto;\n      top: auto;\n    ";
}, top, mediaQueries.tablet, mediaQueries.largePhone, mediaQueries.largePhone, function(props) {
    return props.mobileFullscreen && "\n    @media ".concat(mediaQueries.largePhone, " {\n      &__content, &__content.--variant-embedded {\n        max-height: 100%;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        transform: none;\n        border-radius: 0px;\n        justify-content: flex-start;\n        overflow: scroll;\n        -webkit-overflow-scrolling: touch;\n      }\n    }\n  ");
}, function(props) {
    return props.mobileCentered && "\n    @media ".concat(mediaQueries.largePhone, " {\n      &__content, &__content.--variant-embedded {\n        max-height: 100%;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        transform: none;\n        border-radius: 0px;\n        justify-content: center;\n        overflow: scroll;\n        -webkit-overflow-scrolling: touch;\n      }\n    }\n  ");
});
export default function(props) {
    var children = props.children, _props_isOpen = props.isOpen, isOpen = _props_isOpen === void 0 ? false : _props_isOpen, modifierClassName = props.className, _props_fancy = props.fancy, fancy = _props_fancy === void 0 ? false : _props_fancy, _props_mobileFullscreen = props.mobileFullscreen, mobileFullscreen = _props_mobileFullscreen === void 0 ? true : _props_mobileFullscreen, _props_noPadding = props.noPadding, noPadding = _props_noPadding === void 0 ? false : _props_noPadding, _props_scrollable = props.scrollable, scrollable = _props_scrollable === void 0 ? false : _props_scrollable, _props_variant = props.variant, variant = _props_variant === void 0 ? 'default' : _props_variant, rest = _object_without_properties(props, [
        "children",
        "isOpen",
        "className",
        "fancy",
        "mobileFullscreen",
        "noPadding",
        "scrollable",
        "variant"
    ]);
    useEffect(function() {
        // react-modal adds a pesky overflow: hidden to the body, so we unset
        // it when the modal is closed to ensure the user can still scroll
        if (!isOpen) {
            document.body.style.overflow = 'unset';
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ _jsx(StyledModal, _object_spread_props(_object_spread({}, rest), {
        fancy: fancy,
        mobileFullscreen: mobileFullscreen,
        modifierClassName: modifierClassName,
        noPadding: noPadding,
        scrollable: scrollable,
        variant: variant,
        isOpen: isOpen,
        children: children
    }));
};
